// @flow

import * as React from 'react';
import isNumber from 'lodash/isNumber';
import useSheet from '../../jss';
import Button from '../commons/Button';
import DateComponent from '../commons/DateComponent';

type Props = {
  deposit?: number,
  depositLeft?: number,
  displayEditButton?: boolean,
  endDate?: string,
  isRestricted: boolean,
  onEdit?: () => void,
  sheet: object,
  spending?: number,
  spendingLeft?: number,
  restrictedEndDate?: string
};

const defaultProps = {
  deposit: undefined,
  depositLeft: undefined,
  displayEditButton: false,
  endDate: undefined,
  onEdit: undefined,
  spending: undefined,
  spendingLeft: undefined,
  restrictedEndDate: undefined
};

function LimitCommitment({
  deposit,
  depositLeft,
  displayEditButton,
  endDate,
  isRestricted,
  onEdit,
  sheet: { classes },
  spending,
  spendingLeft,
  restrictedEndDate
}: Props) {
  return (
    <div>
      <h2>You have the following commitment in place:</h2>
      <div className={classes.box}>
        <ul className={classes.list}>
          {isNumber(deposit) && (
            <li>
              <span>Total deposit amount: ${deposit}</span>
              <span className={classes.note}> (${depositLeft} left)</span>
            </li>
          )}
          {isNumber(spending) && (
            <li>
              <span>Total spending amount: ${spending}</span>
              <span className={classes.note}> (${spendingLeft} left)</span>
            </li>
          )}
          <li>
            <span>In place until </span>
            <DateComponent date={endDate} format="ddd D MMM YYYY" />
          </li>
          <li>
            <span>You can decrease limits or extend the duration at any time.</span>
          </li>
          {restrictedEndDate && (
            <li>
              <span>You can increase limits or shorten the duration after </span>
              <DateComponent date={restrictedEndDate} format="h:mm a on Do MMM YYYY" />
            </li>
          )}
          {!isRestricted && (
            <li>
              <span>You are eligible to reset limits.</span>
            </li>
          )}
        </ul>
        {displayEditButton && (
          <Button block size="medium" kind="secondary" onClick={onEdit} style={{ width: '100px' }}>
            Edit
          </Button>
        )}
      </div>
    </div>
  );
}

LimitCommitment.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    box: {
      backgroundColor: theme.color.basis4,
      borderRadius: theme.borderRadius.small,
      color: theme.color.white,
      padding: theme.spacing.default,
      marginBottom: theme.spacing.default
    },
    list: {
      listStyle: 'none'
    },
    note: {
      color: theme.color.danger,
      fontSize: theme.fontSize.small
    }
  };
}

export default useSheet(applyStyles)(LimitCommitment);
